import React from "react";
import styled from "@emotion/styled";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { PhoneMask } from "@components/mask-components";

const sharestylebtn = `
  width: 100%;
  height: 45px;
  max-width: 300px;
  border-radius: 50px;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  padding: 0 1.5rem;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  font-family: var(--font-family);
  column-gap: 8px;
    margin: auto;
`;

const ButtonWhatsapp = styled.button`
  ${sharestylebtn}
  background-color: var(--color-brand-green-main);
`;

interface WsButtonWhatsappProps {
  onClick: () => void;
  phone: string | number;
  style?: React.CSSProperties;
}

const WsButtonWhatsapp: React.FC<WsButtonWhatsappProps> = ({
  onClick,
  phone,
  style,
}) => {
  return (
    <ButtonWhatsapp onClick={onClick} style={style}>
      <WhatsAppIcon />
      WhatsApp
      <PhoneMask value={phone} displayType="text" />
    </ButtonWhatsapp>
  );
};

export default WsButtonWhatsapp;
